import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const stockOpnameAdjustmentRBAC = {
  pageID: '59be7f213d1f38a07d3f4e4b49ee7177',
  elementID: {
    ViewPage: 'e4b0924a0f4d824284235c736045f061',
    AksiAssign: '89930c3b0415ea11b11c830df6b21928',
    AksiBatalkan: '948d30c7adf1a350ffd52289db30fb7b',
    AksiPrintStockOpname: 'dcece1b6cef1a350fd458482d35bd0a3',
    AksiReassign: '860bbb07adf1a35145f4013213d068e7',
    AksiRecount: '0c13aa9b8cf703c4ee57bbc176476a89',
    AksiReview: '64bff513b015ea11b11cb91432de678f',
    AksiSubmit: '9acce4b08e53f4f9d853d9dc55b4a671',
    AksiAdjust: 'b063a24db54dfc2bd5c347d27f7ea516',
    AksiPrintPreviewReport: 'c0286b66ceaddec9dc036225f13982f4',
    AksiCountList: '1250aa2cf1148c479bb8ebe072c51c9a',
    AksiPrintAdjustmentReport: '54562ffc233bca714d145bacbce22eea',
    AksiPrintWriteOffReport: '37205b3ad280934657b9bc4f90a575cc',
    AksiPrintPreviewExcelReport: '519dbda384b54e3d9b65042cdd3d1f3b',
    AksiPrintAdjustmentExcelReport: 'cb7b77274cc5453cd7c0ebf5ee4123a1',
    AksiPrintWriteOffExcelReport: 'aa980200b47b5ba835add3552bfb3873',
  },
} as const

export const useRBACStockOpnameAdjustmentPage = createUseRBAC(stockOpnameAdjustmentRBAC.elementID)

export type UseRBACStockOpnameAdjustmentPageType = ReturnType<
  typeof useRBACStockOpnameAdjustmentPage
>
